import styled from 'styled-components'

export const Container = styled.div`
  //position:relative
  width: 100%;
  max-width: 100rem;
  padding: 2rem 1rem 1rem;
  overflow: hidden;

  .title {
    font-size: 1.5rem;
    line-height: 1.8125rem;
    font-weight: 700;
    color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};
    padding-left: 1rem;
  }

  h4 {
    width: 96px;
    margin: 0.5rem 0rem 0.5rem 0;
    font-weight: normal;
  }
`

export const SubscritionCoursesContainer = styled.div`
  width: 100%;
  padding: 1rem;
  display: flex;
  flex-wrap: wrap;
  gap: 32px;
  justify-content: space-between;
  margin-top: 2rem;

  .empty-text {
    font-size: 1.5rem;
    line-height: 1.8125rem;
    font-weight: 700;
    color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};
    text-align: center;

    width: 100%;
  }

  @media only screen and (max-width: 800px) {
    justify-content: center;
  }
`

export const InputWrapper = styled.div`
  background: ${({ theme }) => `rgb(${theme.component.background})`};
  box-shadow: 0px 7px 24px -5px rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(2px);
  border-radius: 4px;
  margin: 2rem 2rem 2rem 1rem;
  height: 3rem;
  padding: 0.5rem 1rem;
  display: flex;
  align-items: center;

  svg {
    height: 0.725rem;
    margin-right: 0.5rem;
    color: ${({ theme }) => `rgb(${theme.grayscale[200]})`};
  }

  input {
    border: none;
    width: 100%;
    background: transparent;
    color: ${({ theme }) => `rgb(${theme.grayscale[200]})`};

    &::placeholder {
      color: ${({ theme }) => `rgb(${theme.grayscale[200]})`};
    }
  }
`
export const PaginateWrapper = styled.div`
  width: 100vw;
  max-width: 1300px;
  margin: 0 auto;
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const FormWrapper = styled.div`
  display: flex;
  padding: 0 1rem;
  width: 90%;
  flex-wrap: wrap;

  form {
    display: flex;
    flex-direction: column;
    width: 100%;

    .filterTitle {
      display: flex;
    }
  }

  @media only screen and (min-width: 800px) {
    form {
      padding-right: 1rem;
      flex-direction: row;
      align-items: center;
      margin: 0 0 0 auto;
    }

    div {
      margin: 0 1rem;
    }
  }

  @media only screen and (min-width: 1170px) {
    form {
      width: 50%;
    }
  }
`
